// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__t9AH0","modal":"Modal_modal__cX8N0","slide-down":"Modal_slide-down__pU+is"};